import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findAllMenu () {
    return axios.post(global.BASE_ACL + '/menu/findAllMenu')
  },
  roleDelete (params) {
    return axios.post(global.BASE_ACL + '/role/deleteRole', params)
  },
  roleInsert (params) {
    return axios.post(global.BASE_ACL + '/role/insertRole', params)
  },
  roleUpdate (params) {
    return axios.post(global.BASE_ACL + '/role/updateRole', params)
  },
  menuFindWhenUpdate (params) {
    return axios.post(global.BASE_ACL + '/menu/findWhenUpdate', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/syssetting/roleList.js